import styled from "@emotion/styled";
import { LAYER_ONE } from "constants/z-index";
export const StyledMobileOnePagerWithImageContentComponent = styled.div`
  width: 100vw;
  display: inline-flex;
  justify-content: space-around;

  .mobile-content-wrapper {
    display: flex;
    z-index: ${LAYER_ONE};
    justify-content: center;
    align-items: center;
  }
`;
